import { Box, Grid } from "@mui/material";
import {
  StyledMenuTitle,
  StyledMenuSubtitle,
  StyledMenuButton,
  StyledMenuLink,
  StyledMenuHeading,
  AideCardTitle,
  AideCardSubtitle,
} from "../../style";
import { useNavigate } from "react-router";
import { M_PRIME_ADAPT, M_PRIME_RENOV, PRISEDERDV } from "../../../../../constants/routes";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { StyledPaper } from "@hcl-commerce-store-sdk/react-component";
import { HeaderMegaMenuSX } from "../../../headerMegaMenu";
import { DesktopActionCard } from "../DesktopActionCards";
import AsyncCall from "../../../../../_foundation/gtm/async.service";
import { CLICK } from "../../../../../_foundation/constants/gtm";

interface DesktopServicesMenuProps {
  closeHeaderMenu?: () => any;
  menuLinksData: Record<string, any>;
}

const DesktopServicesMenu: React.FC<DesktopServicesMenuProps> = ({ closeHeaderMenu, menuLinksData }) => {
  const navigate = useNavigate();

  const serviceData = menuLinksData?.services;
  const NAV_LEVEL_1 = "Pose Et Services";

  const handleCardClick = (card: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "Les Aides",
      nav_level_3: card?.title || "",
      nav_type: "cta",
      btn_label: card?.title || "",
      click_destination: card?.link || "",
    });
    closeHeaderMenu && closeHeaderMenu();
    navigate(card?.link);
  };

  const onServicsBtnClick = () => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "",
      nav_level_3: "",
      nav_type: "cta",
      btn_label: "Voir tous nos services",
      click_destination: serviceData?.url || "",
    });
    closeHeaderMenu && closeHeaderMenu();
    navigate(serviceData?.url);
  };

  const onItemClick = (item: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      click_section: "menu",
      nav_level_1: NAV_LEVEL_1,
      nav_level_2: "Les services Lapeyre",
      nav_level_3: item?.label || "",
      nav_type: "link",
      btn_label: item?.label || "",
      click_destination: item?.link || "",
    });
    closeHeaderMenu && closeHeaderMenu();
    navigate(item?.link);
  };

  return (
    <StyledPaper className="megamenu-wrapper expanded-menu-mega-menu-v2" sx={HeaderMegaMenuSX.wrapper}>
      <Box>
        {/* Section Title */}
        <StyledMenuTitle sx={{ mb: 1 }}>{serviceData?.label}</StyledMenuTitle>
        <StyledMenuSubtitle sx={{ mb: 1 }}>{serviceData?.description}</StyledMenuSubtitle>

        <Grid container>
          {/* LEFT – Services Menu */}
          <Grid item xs={12} md={4} lg={3}>
            <StyledMenuHeading>Les services Lapeyre</StyledMenuHeading>

            <Box sx={{ display: "flex", flexDirection: "column", mt: 2 }}>
              {serviceData?.list.map((item, index) => (
                <StyledMenuLink
                  // sx={{ textTransform: "none", color: "#848484" }}
                  style={{
                    color: "#000",
                    fontFamily: "Montserrat",
                    fontSize: "15px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "20px",
                  }}
                  key={index}
                  onClick={() => onItemClick(item)}>
                  {item?.icon?.length > 0 && (
                    <Box component="img" src={item.icon} sx={{ width: 20, height: 20, mr: 1, objectFit: "contain" }} />
                  )}
                  <span>{item.label}</span>
                </StyledMenuLink>
              ))}
            </Box>

            {/* Button */}
            <Box sx={{ mt: 15 }}>
              <StyledMenuButton onClick={onServicsBtnClick}>
                Voir tous nos services
                <ArrowForwardIcon />
              </StyledMenuButton>
            </Box>
          </Grid>

          {/* MIDDLE – Aides Cards */}
          <Grid
            item
            xs={12}
            md={4}
            lg={5}
            sx={{
              pl: 2,
              pr: 2,
              overflow: "hidden", // Prevent hover bleed
            }}>
            <StyledMenuHeading sx={{ mb: 2 }}>Les aides</StyledMenuHeading>

            {[
              {
                img: "/images/header/maprimerenov.svg",
                title: "MaPrimeAdapt’",
                desc: "Adaptation du logement aux seniors et PMR",
                link: M_PRIME_ADAPT,
              },
              {
                img: "/images/header/maprimeadapt.svg",
                title: "MaPrimeRenov’",
                desc: "Rénovation énergétique de votre habitation",
                link: M_PRIME_RENOV,
              },
            ].map((card, i) => (
              <Box
                key={i}
                onClick={() => handleCardClick(card)}
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  backgroundColor: "#EFF3F6",
                  borderRadius: "12px",
                  padding: "20px",
                  mb: 2,
                  flexDirection: { xs: "column", sm: "row" },
                  textAlign: { xs: "center", sm: "left" },
                  maxWidth: "400px",
                  width: "100%",
                  height: "30%",
                  cursor: "pointer",
                }}>
                <Box
                  component="img"
                  src={card.img}
                  alt={card.title}
                  sx={{
                    width: { xs: "80%", sm: 100 },
                    maxWidth: 120,
                    objectFit: "contain",
                  }}
                />

                <Box>
                  <AideCardTitle>{card.title}</AideCardTitle>
                  <AideCardSubtitle>{card.desc}</AideCardSubtitle>
                </Box>
              </Box>
            ))}
          </Grid>

          <Grid item lg={0.1} md={0.1} xs={0.1}>
            <Box
              sx={{
                width: "2px",
                backgroundColor: "#EFEFEF",
                height: "100%",
                ml: 5,
              }}
            />
          </Grid>
          {/* RIGHT – Red Card */}
          <Grid
            item
            xs={12}
            lg={3}
            md={2}
            sx={{
              flexBasis: { md: "280px" },
              maxWidth: { md: "280px" },
              "@media (max-width:1000px)": {
                width: "265px",
                maxWidth: "265px",
                flexBasis: "265px",
              },
              flexGrow: 0,
              mt: { xs: 3, sm: 0.5 , lg: 0 },
              ml: 11,
            }}>
            <DesktopActionCard
              closeHeaderMenu={closeHeaderMenu}
              cardTheme="red"
              chipName="AIDE"
              title="BESOIN DE CONSEIL"
              desc="Nos équipes sont là pour vous conseiller à chaque étape de votre projet. Prenez rendez-vous avec un
                  expert."
              btnLabel="PRENDRE RENDEZ-VOUS"
              ctaLink={PRISEDERDV}
              gtmData={{
                click_section: "menu",
                nav_level_1: NAV_LEVEL_1,
                nav_level_2: "",
                nav_level_3: "",
                nav_type: "cta",
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default DesktopServicesMenu;
